import { useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import useClickOutside from "../../../../hooks/useClickOutside";
import styles from "./SelectMenus.module.scss";

type OptionsSelectorProps = {
  value: string;
  options: string[];
  placeholder?: string;
  onChange: (value: string) => void;
};

export default function OptionsSelector({
  value,
  options,
  placeholder,
  onChange,
}: OptionsSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectOption = (option: string) => {
    onChange(option);
    setIsOpen(false);
  };

  useClickOutside(menuRef, () => setIsOpen(false));

  return (
    <div
      className={styles.selectContainer}
      onBlur={() => setIsOpen(false)}
      ref={menuRef}
    >
      <div className={styles.selectBox} onClick={toggleDropdown}>
        {value || placeholder}
        <span className={`${styles.icon} ${isOpen ? styles.open : ""}`}>
          <FaChevronDown />
        </span>
      </div>
      {isOpen && (
        <div className={styles.optionsList}>
          {options.map((option: string, index: number) => (
            <div
              key={index}
              className={styles.option}
              onClick={() => selectOption(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
